module.exports = __webpack_public_path__ + "static/img/01bg.7247660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/05sportRecord/01bg.png
// module id = UMpW
// module chunks = 0